import { generateEncryptData } from "../helper/payloadHelper";
import Api from "./Api";
import { createQueryString } from "./ApiHelper";

export default {
  GetFnBList(payload, options = {}) {
    const config =
      options && options.skipCache
        ? { headers: { skipcacheforcron: "1" } }
        : {};
    return Api().post("/pos/admin/getfnbitems", payload, config);
  },
  GetFnbCheckVendorRates(payload) {
    return Api().post("/pos/admin/getMissingVendorRatesItem", payload);
  },
  GetFnBCategories(payload) {
    const query = createQueryString(payload);
    console.log("query GetFnBCategories", query);
    return Api().get(`/pos/admin/getfnbcategories${query}`);
  },
  GetFnBSubCategories(payload) {
    return Api().get(`/pos/admin/getfnbsubcategories/${payload.parentid}`);
  },
  GetCategoryWiseFnbItems(payload) {
      return Api().get(`/pos/getCategoryWiseFnbItems/${payload.cinema_id}`)
  },
  CallCheckout(payload) {
    return Api().post(`/pos/admin/checkout`, payload);
  },
  GetFnBAdditionalCharges(payload) {
    return Api().get(`/pos/admin/getfnbaddtionalprice/${payload.item_id}`);
  },
  async OnFinalOrderSubmit(payload) {
    payload = await generateEncryptData(payload);
    return Api().post(`/pos/admin/generate-pos-fnb-order`, payload);
  },
  OnAddRawMaterialIntoStore(payload) {
    return Api().post("/pos/admin/addrawmaterialintostore", payload);
  },
  OnSaveFnBPhoneNumber(payload) {
    return Api().put("/pos/admin/fnbsavephonenumber", payload);
  },
  OnChangeFnBPaymnetStatus(payload) {
    return Api().put("/pos/admin/fnbsetpaymentstatus", payload);
  },
  GetPosFnbFooterMenus() {
    return Api().get("/pos/admin/posfnbfootermenus");
  },
  GetFnbAlternateItems(payload) {
    return Api().get(`/pos/admin/alternateitems/${payload.item_id}`);
  },
  ReserveFnbItems(payload) {
    return Api().post(`/pos/admin/reserveFnbItems`, payload);
  },
  SaveFnbItems(payload) {
    return Api().post(`/api/pos/save-fnb-items`, payload);
  },
  VerifyConcessionRedemption(payload) {
    return Api().post(`/pos/admin/verify-concession-redemption`, payload);
  },
  AdmitConcessionRedemption(payload) {
    return Api().post(`/pos/admin/admit-concession-redemption`, payload);
  },
};



// WEBPACK FOOTER //
// ./src/services/Pos_Fnb_Service.js